import React, { useContext, useEffect, useState } from "react";
import SidebarContext from "../../../context/SidebarContext";
import { Box, Tab } from "@mui/material";
import Header from "./Header";
import OrderList from "./OrderList";
import CataloguesList from "./Category/CataloguesList";
import OverView from "./Category/OverView";
import IssueComponent from "./Category/IssueComponent";
import { TabContext, TabList, TabPanel } from "@mui/lab";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { db, storage } from "../../../firebaseConfig";
import { getDownloadURL, ref } from "firebase/storage";
import ShipmentSetting from "./Category/ShipmentSetting";

function Order() {
  const { open } = useContext(SidebarContext);
  const [refresh, setrefesh] = useState(false);

  const [value, setValue] = React.useState("1");

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  const { id } = useParams();
  const [storeDetails, setStoreDetails] = useState([]);

  async function handler() {
    try {
      if (id) {
        const docRef = doc(db, "stores", id);
        const docSnap = await getDoc(docRef);

        if (docSnap.exists()) {
          const data = docSnap.data();

          // Update productImage URLs
          if (data.products && Array.isArray(data.products)) {
            const updatedProducts = await Promise.all(
              data.products.map(async (product) => {
                if (product.productImage) {
                  try {
                    const imageRef = ref(storage, product.productImage);
                    const newUrl = await getDownloadURL(imageRef);
                    return {
                      ...product,
                      productImage: newUrl, // Update productImage with the new URL
                    };
                  } catch (error) {
                    console.error(
                      "Error fetching image URL for product:",
                      product.productName,
                      error
                    );
                    return product; // Return the product without changes if there's an error
                  }
                }
                return product;
              })
            );

            // Set updated products in storeDetails
            setStoreDetails({
              ...data,
              products: updatedProducts,
            });
          } else {
            setStoreDetails(data); // If no products, just set the data as is
          }
        } else {
          console.log("No such document!");
        }
      }
    } catch (error) {
      console.log(error, "error");
    }
  }

  useEffect(() => {
    handler();
  }, [refresh]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "96vh",
        margin: "20px",
        marginRight: "0px",
        width: open === true ? "calc(98vw - 240px)" : "calc(98vw - 80px)",
        backgroundColor: "white",
        padding: "20px",
        borderRadius: "12px",
      }}
    >
      <Box sx={{ borderBottom: "1px solid #E5E5E8" }}>
        <Header storeData={storeDetails} id={id} />
      </Box>

      <Box sx={{ width: "100%", typography: "body1" }}>
        <TabContext value={value}>
          <Box sx={{ borderBottom: 1, borderColor: "divider" }}>
            <TabList onChange={handleChange} aria-label="lab API tabs example">
              <Tab label="Order" value="1" />
              <Tab label="Catalogues" value="2" />
              <Tab label="OverView" value="3" />
              <Tab label="Issue" value="4" />
              <Tab label="Shipment & Settings" value="5" />
            </TabList>
          </Box>
          <TabPanel value="1">
            <OrderList />
          </TabPanel>
          <TabPanel value="2">
            <CataloguesList
              storeData={storeDetails}
              id={id}
              refresh={setrefesh}
              refreshValue={refresh}
            />
          </TabPanel>
          <TabPanel value="3">
            <OverView storeData={storeDetails} />
          </TabPanel>
          <TabPanel value="4">
            <IssueComponent />
          </TabPanel>
          <TabPanel value="5">
            <ShipmentSetting />
          </TabPanel>
        </TabContext>
      </Box>
    </Box>
  );
}

export default Order;
